import { Link } from "react-router-dom";

const Order = ({ inspData, onClose }) => {
  //출발보고 URL 검색 URL
  //const IMAGE_URL = "http://tms.idaehan.com:8080/rn/rest/depart/getOrgAttachImage/" + inspData.tmsOdrNo;
  const IMAGE_URL =
    "https://tms.idaehan.com:8443/rn/rest/depart/getOrgAttachImage/" +
    inspData.tmsOdrNo;

  const SERARCH_DRRT_URL1 = IMAGE_URL + "/DPRT_01.do";
  const SERARCH_DRRT_URL2 = IMAGE_URL + "/DPRT_02.do";
  const SERARCH_ARRV_URL1 = IMAGE_URL + "/ARRV_01.do";
  const SERARCH_ARRV_URL2 = IMAGE_URL + "/ARRV_02.do";

  return (
    <>
      <ul className="mlist">
        <li className="head">
          <div>공급업체</div>
        </li>
        <li className="fullsc">
          <div>{inspData.vndrNm}</div>
        </li>
        <li className="head">
          <div>실공급업체</div>
        </li>
        <li className="fullsc">
          <div>{inspData.rvndrNm}</div>
        </li>
        <li className="head">
          <div>상차지</div>
        </li>
        <li className="fullsc">
          <div>{inspData.loadAreaAddr}</div>
        </li>
        <li className="fullhead">
          <div>
            출발보고 사진1
            <Link
              to="#"
              onClick={() => window.open(SERARCH_DRRT_URL1, "_blank")}
            >
              [사진 링크]
            </Link>
          </div>
        </li>
        <li className="photo">
          <img src={SERARCH_DRRT_URL1} />
        </li>
        <li className="fullhead">
          <div>
            출발보고 사진2
            <Link
              to="#"
              onClick={() => window.open(SERARCH_DRRT_URL2, "_blank")}
            >
              [사진 링크]
            </Link>
          </div>
        </li>
        <li className="photo">
          <img src={SERARCH_DRRT_URL2} />
        </li>
        <li className="fullhead">
          <div>
            도로영수증 사진1
            <Link
              to="#"
              onClick={() => window.open(SERARCH_ARRV_URL1, "_blank")}
            >
              [사진 링크]
            </Link>
          </div>
        </li>
        <li className="photo">
          <img src={SERARCH_ARRV_URL1} />
        </li>
        <li className="fullhead">
          <div>
            계량증명서 사진2
            <Link
              to="#"
              onClick={() => window.open(SERARCH_ARRV_URL2, "_blank")}
            >
              [사진 링크]
            </Link>
          </div>
        </li>
        <li className="photo">
          <img src={SERARCH_ARRV_URL2} />
        </li>
      </ul>
    </>
  );
};

export default Order;
